import * as PropTypes from 'prop-types'

const DashboardShape = PropTypes.shape({

})

export { DashboardShape }
